var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseTable',{attrs:{"headers":_vm.tableHeaders,"items":_vm.participationList,"pagination":_vm.pagination,"loading":_vm.isLoading,"on-row-click":_vm.view},on:{"update:page":_vm.getAll},scopedSlots:_vm._u([{key:"item.viesas",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(!!item.viesas ? _vm.$t('common.yes') : _vm.$t('common.no'))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }